<template>
  <!-- The site's hero ornament: a 200px grid fading out from one corner, a few
       filled squares, and a blurred sky → indigo wash. Fills its nearest
       positioned ancestor and sits behind that ancestor's content (give the
       ancestor `relative isolate` or a z-index of its own).

       `subtle` behind working UI (the generator's left panel, the dashboard
       header); `hero` behind a marketing headline. Purely decorative, inline
       SVG and CSS, so it costs no request. -->
  <div class="pointer-events-none absolute inset-0 -z-10 overflow-hidden" aria-hidden="true">
    <svg
      class="absolute inset-0 h-full w-full stroke-white/10"
      :class="variant === 'hero'
        ? '[mask-image:radial-gradient(100%_100%_at_top_right,white,transparent)]'
        : 'opacity-50 [mask-image:radial-gradient(100%_100%_at_top_left,white,transparent)]'"
    >
      <defs>
        <pattern :id="patternId" width="200" height="200" x="50%" y="-1" patternUnits="userSpaceOnUse">
          <path d="M.5 200V.5H200" fill="none" />
        </pattern>
      </defs>
      <svg x="50%" y="-1" class="overflow-visible fill-gray-800/20">
        <path d="M-200 0h201v201h-201Z M600 0h201v201h-201Z M-400 600h201v201h-201Z M200 800h201v201h-201Z" stroke-width="0" />
      </svg>
      <rect width="100%" height="100%" stroke-width="0" :fill="`url(#${patternId})`" />
    </svg>
    <div class="absolute left-[calc(50%-4rem)] top-10 transform-gpu blur-3xl sm:left-[calc(50%-18rem)] lg:left-48 lg:top-[calc(50%-30rem)] xl:left-[calc(50%-24rem)]">
      <div
        class="aspect-[1108/632] w-[69.25rem] bg-gradient-to-r from-sky-300 to-indigo-600"
        :class="variant === 'hero' ? 'opacity-20' : 'opacity-10'"
        style="clip-path: polygon(73.6% 51.7%, 91.7% 11.8%, 100% 46.4%, 97.4% 82.2%, 92.5% 84.9%, 75.7% 64%, 55.3% 47.5%, 46.5% 49.4%, 45% 62.9%, 50.3% 87.2%, 21.3% 64.1%, 0.1% 100%, 5.4% 51.1%, 21.4% 63.9%, 58.9% 0.2%, 73.6% 51.7%)"
      />
    </div>
  </div>
</template>

<script setup>
import { useId } from 'vue'

defineProps({
  variant: { type: String, default: 'subtle' },
})

// SSR-stable, so two backdrops on one page never share a <pattern>.
const patternId = `grid-${useId()}`
</script>
